// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"688":"badf541d","9599":"c132bf7d"}[chunkId] || chunkId) + "." + {"312":"206903ea6d69ed35","688":"82447834f2d40811","8358":"031d03adcc53c305","9599":"7871f13e85f64416"}[chunkId] + ".js";
};